<template>
  <nav class="navbar" v-if="$route.name !== 'Lanzamiento'">
    <router-link to="/">
      <img
        class="navbar__logo"
        src="@/assets/images/top_logos.png"
        alt="DiDi Shark Tank"
      />
    </router-link>

    <ul class="navbar__menu">
      <li>
        <router-link to="/concurso" active-class="isActive"
          >El concurso</router-link
        >
      </li>
      <li><router-link to="/">Capítulos</router-link></li>
      <li><router-link to="/emprendimientos">Emprendimientos</router-link></li>
      <li>
        <router-link to="/premio" active-class="isActive">Premio</router-link>
      </li>
      <li>
        <router-link to="/jurado" active-class="isActive">Jurado</router-link>
      </li>
    </ul>

    <div class="navbar__social">
      <a href="https://www.facebook.com/DiDiColombia/" target="_blank">
        <img src="@/assets/images/facebook.png" alt="DiDi Shark Tank" />
      </a>
      <a
        href="https://www.youtube.com/channel/UC4043jVyl39si8xvI99v5ww"
        target="_blank"
      >
        <img src="@/assets/images/youtube.png" alt="DiDi Shark Tank" />
      </a>
      <a href="https://twitter.com/didicolombia" target="_blank">
        <img src="@/assets/images/twitter.png" alt="DiDi Shark Tank" />
      </a>
      <a href="https://www.instagram.com/didicolombia/" target="_blank">
        <img src="@/assets/images/instagram.png" alt="DiDi Shark Tank" />
      </a>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.navbar {
  width: 100%;
  background: $dark-blue;
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include phone {
    display: none;
  }

  &__logo {
    width: 340px;
  }

  &__menu {
    list-style: none;
    display: flex;
    margin-left: 4rem;

    li:not(:last-child) {
      margin-right: 1rem;
    }
    a {
      text-decoration: none;
      color: white;
      &:active,
      &:visited {
        color: white;
      }
    }

    .isActive {
      border-bottom: 1px solid white;
    }
  }

  &__social {
    display: flex;

    a:not(:last-child) {
      margin-right: 1rem;
    }

    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
    }
  }
}
</style>